import PremiumOffer from "./PremiumOffer";

const StoreGrid = ({}) => {
  return (
    <>
      <div className="container">
        <div className="row ">
          <div className="col">
            <div className="row">
              <PremiumOffer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreGrid;
